import TermsOfService from "./terms-of-service";
import PrivacyPolicy from "./privacy-policy";

export { TermsOfService, PrivacyPolicy };
